import * as React from "react";

function SvgNewDemand(props) {
  return <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7.633 15v-4.2M7.633 5.2V1M5.421 8H1M15 8h-4.422M2.473 13L5.6 10.03M9.768 6.07l3.127-2.97M12.896 13L9.77 10.03M5.6 6.07L2.476 3.1" stroke="#F7C96E" /></svg>;
}

export default SvgNewDemand;